"use client";
import { cn } from "@lib/utils";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { ComponentPropsWithoutRef, ComponentRef, Ref } from "react";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverArrow = PopoverPrimitive.Arrow;

const PopoverClose = PopoverPrimitive.Close;

const PopoverContent = ({
	ref,
	className,
	align = "center",
	sideOffset = 4,
	...props
}: ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
	ref?: Ref<ComponentRef<typeof PopoverPrimitive.Content>>;
}) => (
	<PopoverPrimitive.Portal>
		<PopoverPrimitive.Content
			ref={ref}
			align={align}
			sideOffset={sideOffset}
			className={cn(
				"bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-xl border p-4 shadow-xs outline-hidden",
				className
			)}
			{...props}
		/>
	</PopoverPrimitive.Portal>
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverArrow, PopoverClose, PopoverContent };
